import {useAppBaseAPI} from '@medad-sep/core';

import {config} from '../../../config/env';

export const useKy = () => {
  return useAppBaseAPI(config.baseApiUrl, config.tenant);
};
